module.exports = __webpack_public_path__ + "static/media/member nalas-05.86e59281.jpg";